import { render, staticRenderFns } from "./LessonDropdown.vue?vue&type=template&id=630e5a3c&"
import script from "./LessonDropdown.vue?vue&type=script&lang=ts&"
export * from "./LessonDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports